import * as React from 'react';

import { getArticleSchema } from './getArticleSchema';
import { getBreadcrumbSchema } from './getBreadcrumbSchema';
import { getFAQSchema } from './getFAQSchema';

const isValidJson = (json: string) => {
  try {
    JSON.parse(json);
    return true;
  } catch (e) {
    return false;
  }
};

/** For use in Gatsby Head API only */
export const Schemas = ({ data, pageContext }) => {
  const { siteLang, slug } = pageContext;
  const langKey = siteLang.split('-')[0];
  const page = data?.prismicPage?.data?.body;
  const isHome = slug
    ? ['/', `/${langKey}/`, `/${langKey}`].includes(slug) ||
      (['ar-sa', 'ar-kw', 'ar-ae'].includes(siteLang) &&
        slug === `/${siteLang}/`)
    : false;
  const faqSchema = getFAQSchema(page);
  const breadcrumbSchema = getBreadcrumbSchema(slug);
  const articleSchema = getArticleSchema(data);
  const websiteSchema = isValidJson(pageContext?.global?.website_schema?.text)
    ? pageContext?.global?.website_schema?.text
    : undefined;
  const organizationSchema = isValidJson(
    pageContext?.global?.organization_schema?.text
  )
    ? pageContext?.global?.organization_schema?.text
    : undefined;
  const customSchema = isValidJson(data?.prismicPage?.data?.custom_schema?.text)
    ? data?.prismicPage?.data?.custom_schema?.text
    : isValidJson(data?.prismicFacilityGroup?.data?.custom_schema?.text)
      ? data?.prismicFacilityGroup?.data?.custom_schema?.text
      : undefined;

  return (
    <>
      {isHome && organizationSchema && (
        <script type="application/ld+json">{organizationSchema}</script>
      )}
      {isHome && websiteSchema && (
        <script type="application/ld+json">{websiteSchema}</script>
      )}
      {faqSchema && <script type="application/ld+json">{faqSchema}</script>}
      {articleSchema && (
        <script type="application/ld+json">{articleSchema}</script>
      )}
      {breadcrumbSchema && (
        <script type="application/ld+json">{breadcrumbSchema}</script>
      )}
      {customSchema && (
        <script type="application/ld+json">{customSchema}</script>
      )}
    </>
  );
};
